import { styled } from '@mui/material/styles';

const Main = styled('main')(({ theme }) => ({
    flexGrow: 1,
    padding: 0,
    width: '100%',
    maxWidth: '100vw',
    overflow: 'hidden',
    background: 'linear-gradient(135deg, #F6F7F9 0%, #fefefe 100%)',
}));

export default Main;
